import { render, staticRenderFns } from "./ModuleDashboardAdminComponent.vue?vue&type=template&id=3b3a1716&scoped=true"
import script from "./ModuleDashboardAdminComponent.vue?vue&type=script&lang=js"
export * from "./ModuleDashboardAdminComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3a1716",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b3a1716')) {
      api.createRecord('3b3a1716', component.options)
    } else {
      api.reload('3b3a1716', component.options)
    }
    module.hot.accept("./ModuleDashboardAdminComponent.vue?vue&type=template&id=3b3a1716&scoped=true", function () {
      api.rerender('3b3a1716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModuleDashboardAdminComponent.vue"
export default component.exports